<div [ngClass]="classes">
  <div class="gradient-bg" [ngClass]="mode"></div>
  <main class="main-container" (click)="mainContainerClicked()">
    <router-outlet></router-outlet>
  </main>
</div>
